import orderManager from './order-manager'

export default orderManager
